import React, { useState } from 'react';
import FeasibilityListPage from './FeasibilityListPage';
import FeasibilityDetailPage from './FeasibilityDetailPage';

function FeasibilityModule() {
  const [activeFeasibilityId, setActiveFeasibilityId] = useState(null);

  // If a feasibility is selected, show the detail page
  if (activeFeasibilityId) {
    return (
      <FeasibilityDetailPage 
        feasibilityId={activeFeasibilityId} 
        onBack={() => setActiveFeasibilityId(null)} 
      />
    );
  }

  // Otherwise show the list
  return <FeasibilityListPage onOpen={setActiveFeasibilityId} />;
}

export default FeasibilityModule;